import isProcessingTooLong from '../../utils/isProcessingTooLong';
import { CheckCircledIcon, CrossCircledIcon, ProcessingIconDashed } from '../icons/icons';
import parseDate from '../../utils/parseDate';

const RenderStatus = ({ item }) => {
  const status = item?.status?.toLowerCase();
  const createdAt = parseDate(item?.created_at);

  function renderStatusContent(status, createdAt) {
    if (status === 'completed') {
      return {
        icon: <CheckCircledIcon />,
        text: createdAt.toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: '2-digit'
        }),
        fullDate: createdAt.toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })
      };
    } else if (status === 'processing' && !isProcessingTooLong(createdAt)) {
      return {
        icon: <ProcessingIconDashed className="spin" />,
        text: 'Processing'
      };
    } else {
      return {
        icon: <span className="opacity-50"><CrossCircledIcon /></span>,
        text: 'Failed'
      };
    }
  }

  const statusContent = renderStatusContent(status, createdAt);

  return statusContent ? (
    <div className="flex items-center gap-2">
      {statusContent.icon}
      <span className="text-xs font-normal cursor-pointer" title={statusContent.fullDate || ''}>
        {statusContent.text}
      </span>
    </div>
  ) : null;
};

export default RenderStatus;